import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOlympiadData } from '../data/olympiadData';
import Dashboard from '../components/Dashboard';
import Header from '../components/Header';
import WelcomeSection from '../components/WelcomeSection';
import OlympiadSection from '../components/OlympiadSection';
import MockTestSection from '../components/MockTestSection';
import { selectSelectedStudent, selectIsMobileClassroom } from '../store/selectors/studentSelectors';
import { API_ENDPOINTS } from '../config/apiConfig';

// BookDownloadLink component
const BookDownloadLink: React.FC<{ selectedStudent: any }> = ({ selectedStudent }) => {
  // Use centralized CDN URL from apiConfig (same pattern as auth URLs)
  const getBooksBaseUrl = () => {
    return `${API_ENDPOINTS.cdnBaseUrl}/books/`;
  };
  if (!selectedStudent?.grade) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0 8px 0' }}>
      <a
        href={`${getBooksBaseUrl()}LiveOlympiad%20${selectedStudent.grade.replace(/^(Class-[0-9]{2})$/, '$1')}%20Book.pdf`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'none',
          background: 'linear-gradient(90deg, #2563EB 0%, #06B6D4 100%)',
          color: 'white',
          padding: '14px 32px',
          borderRadius: '32px',
          fontWeight: 700,
          fontSize: '1.15rem',
          boxShadow: '0 2px 12px rgba(37,99,235,0.10)',
          transition: 'background 0.2s, box-shadow 0.2s',
          display: 'inline-block',
          textAlign: 'center',
          letterSpacing: '0.01em',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Download your LiveOlympiad Book - All Subjects
      </a>
    </div>
  );
};

const StudentDashboardPage: React.FC = () => {
  const navigate = useNavigate();

  const selectedStudent = useSelector(selectSelectedStudent);
  const isMobileClassroom = useSelector(selectIsMobileClassroom);
  
  React.useEffect(() => {
    if (!selectedStudent) {
      navigate('/select-student');
    }
  }, [selectedStudent, navigate]);
  
  if (!selectedStudent) {
    return null;
  }
  
  const dynamicOlympiadData = getOlympiadData(selectedStudent.school);

  // Filter olympiad data to only show tests for subscribed subjects
  const getSubjectName = (variant: string) => {
    switch (variant) {
      case 'maths':
        return 'Math';
      case 'science':
        return 'Science';
      case 'english':
        return 'English';
      default:
        return 'Math';
    }
  };

  // Show all olympiad cards - no filtering
  const filteredOlympiadData = dynamicOlympiadData;

  return (
    <Dashboard 
      constrained
      header={<Header selectedStudent={selectedStudent} />}
      students={
        <>
          {!isMobileClassroom && <WelcomeSection selectedStudent={selectedStudent} />}
          {!isMobileClassroom && <BookDownloadLink selectedStudent={selectedStudent} />}
          {!isMobileClassroom && <MockTestSection />}
          {isMobileClassroom && <OlympiadSection olympiadData={filteredOlympiadData} />}
        </>
      }
    />
  );
};

export default StudentDashboardPage;